import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Rect, { width: "6", height: "16", x: "4", y: "2", rx: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Rect, { width: "6", height: "9", x: "14", y: "9", rx: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M22 22H2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "AlignEndHorizontal";
const AlignEndHorizontal = memo(themed(Icon));
export {
  AlignEndHorizontal
};
//# sourceMappingURL=align-end-horizontal.js.map
